import React, { useEffect, useState } from "react";
import "./Countdown.scss";

const tick = endDate => {
  const diff = Math.max(0, new Date(endDate) - Date.now());
  return {
    days:    Math.floor(diff / 86400000),
    hours:   Math.floor((diff % 86400000) / 3600000),
    minutes: Math.floor((diff % 3600000)  / 60000),
    seconds: Math.floor((diff % 60000)    / 1000),
    done:    diff === 0,
  };
};

const Countdown = ({ endDate }) => {
  const [time, setTime] = useState(() => tick(endDate));

  useEffect(() => {
    if (time.done) return;
    const id = setInterval(() => setTime(tick(endDate)), 1000);
    return () => clearInterval(id);
  }, [endDate, time.done]);

  if (time.done) return null;

  return (
    <div className="cp-countdown">
      <div className="cp-countdown__label">Campaign ends in</div>
      <div className="cp-countdown__units">
        {[
          { v: time.days,    l: "Days" },
          { v: time.hours,   l: "Hrs" },
          { v: time.minutes, l: "Min" },
          { v: time.seconds, l: "Sec" },
        ].map(({ v, l }) => (
          <div key={l} className="cp-countdown__unit">
            <span className="cp-countdown__num">{String(v).padStart(2, "0")}</span>
            <span className="cp-countdown__unitlabel">{l}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Countdown;
